import script from "./OnsaleView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnsaleView.vue?vue&type=script&setup=true&lang=js"

import "./OnsaleView.vue?vue&type=style&index=0&id=09e2d0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e2d0ea"]])

export default __exports__